<template>
  <div class="flex_frame flex_panel">
    <div class="flex_frame flex_ch">
      <div class="flex_frame flex_icon"
           :style="{ backgroundImage: 'url(' + imagePersonTotal + ')' }">
      </div>
      <div class="flex_frame flex_text1">{{updata.total}} </div>
      <div class="flex_frame flex_text2">总数</div>
    </div>
    <div class="flex_frame flex_ch">
      <div class="flex_frame flex_icon"
           :style="{ backgroundImage: 'url(' + imagePersonMale + ')' }">
      </div>
      <div class="flex_frame flex_text1">{{updata.male}} </div>
      <div class="flex_frame flex_text2">男性</div>
    </div>
    <div class="flex_frame flex_ch">
      <div class="flex_frame flex_icon"
           :style="{ backgroundImage: 'url(' + imagePersonFeMale + ')' }">
      </div>
      <div class="flex_frame flex_text1">{{updata.female}} </div>
      <div class="flex_frame flex_text2">女性</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      imagePersonTotal: require('@/assets/img/zzf_board_person1.png'),
      imagePersonMale: require('@/assets/img/zzf_board_person2.png'),
      imagePersonFeMale: require('@/assets/img/zzf_board_person3.png')
    }
  },
  props: {
    updata: {
      type: Object,
      default: () => ({
        total: 100,
        male: 50,
        female: 50
      })
    }
  },
  mounted() {
    this.initPanel()
  },
  beforeDestroy() {},
  watch: {
    //updata: {
    //  handler(newData) {
    //  },
    // immediate: true, // 初始化后会立即触发一次
    //   deep: true // 深层监听 即遍历所有子对象 对性能稍有影响
    // }
  },
  methods: {
    initPanel() {},
    updatePieOption(newData) {
      console.log(newData)
    }
  }
}
</script>

<style scoped>
.flex_frame {
  border: 0px solid #969696;
  box-sizing: border-box; /* 确保内边距和边框不会影响宽度计算 */
}
.flex_panel {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
}
.flex_ch {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.flex_icon {
  flex: 1;
  align-items: flex-end;
  background-repeat: no-repeat;
  background-position: bottom;
  margin-bottom: 20px;
}
.flex_text1 {
  flex: 0, 0, 60px;
  height: 60px;
  font-weight: bold;
  font-size: 50px;
  color: #ffffff;
  text-align: center;
}
.flex_text2 {
  flex: 1;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
}
</style>